export default __webpack_public_path__ + "static/media/640_dummy2016-kunsthandwerk01-de.660dc1ec.png";